<div class="vh-100">
  <h3 class="text-center space-top-3">Thank you!</h3>
  <h4 class="text-center">You have successfully entered your payment information</h4>
</div>
